import { ref } from "vue";
import useFormSequence from "@/components/form/useFormSequence";

const modalVisible = ref(false);
const fs = ref({}); // the current form sequence in use, with answers
const fsDefinition = ref(); // the form sequence definition
const title = ref(); // the title for the modal window
const titleIcon = ref(); // the icon for the title

/* v8 ignore next */
export default () => {
  function showFormSequenceModal(
    theTitle,
    theTitleIcon,
    formSequenceFunction,
    context,
    submitCallback,
  ) {
    title.value = theTitle;
    titleIcon.value = theTitleIcon;
    fsDefinition.value = formSequenceFunction(
      context,
      submitCallback,
    ).formSequence;
    fs.value = useFormSequence(fsDefinition.value, context);
    modalVisible.value = true;
  }

  function hideFormSequenceModal() {
    modalVisible.value = false;
  }

  return {
    showFormSequenceModal,
    hideFormSequenceModal,
    modalVisible,
    title,
    titleIcon,
    fs,
    fsDefinition,
  };
};
